
define('tpl!ui/pagination/providers/tpl/pages', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<div class=\"grid-row clearfix pagination\">\n    <ul class=\"pages\">\n        <li class=\"first-page\"><span class=\"icon-fast-backward\" title=\""
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "First page", options) : helperMissing.call(depth0, "__", "First page", options)))
    + "\"></span></li>\n        <li class=\"previous\"><span class=\"icon-backward\" title=\""
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Previous", options) : helperMissing.call(depth0, "__", "Previous", options)))
    + "\"></span></li>\n        <li class=\"next\"><span class=\"icon-forward\" title=\""
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Next", options) : helperMissing.call(depth0, "__", "Next", options)))
    + "\"></span></li>\n        <li class=\"last-page\"><span class=\"icon-fast-forward\" title=\""
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Last page", options) : helperMissing.call(depth0, "__", "Last page", options)))
    + "\"></span></li>\n    </ul>\n</div>\n";
  return buffer;
  });
});

